<template>
  <div id="app">
    <SiteNavigation :username="username" />
    <div>
      <router-view />
    </div>
    <footer>
      <p class="version-info">{{ version }}</p>
    </footer>
  </div>
</template>
<script>
import SiteNavigation from "@/components/SiteNavigation";

export default {
  name: "app",
  components: {
    SiteNavigation,
  },
  data() {
    return {
      username: "",
      version: `v${process.env.VUE_APP_VERSION}-${process.env.VUE_APP_PIPELINE_ID}`,
    };
  },
  mounted() {
    // NICHT HIER navigieren - das macht der Router Guard
    // Entfernen Sie alle this.$router.push() Aufrufe
  },
};
</script>

<style>
#app {
  font-family: "Segoe UI", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-size: 100%;
}

body {
  margin: 0;
}

header {
  background-color: #fafafa;
  border-bottom: 1px solid #ddd;
  text-align: center;
}

footer {
  min-height: 3rem;
}

footer p.version-info {
  color: #ddd;
  font-size: 0.8rem;
  padding-right: 1rem;
  padding-top: 3rem;
  text-align: right;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 500;
}

.page-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  padding-bottom: 1.25rem;
  padding-top: 1.25rem;
}

.page-header--buttons {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.page-header h1 {
  font-size: 2.1rem;
  margin: 0.75rem 0;
}

.page-header h2 {
  margin: 0.75rem 0;
}

.page-content {
  margin-top: 1.5rem;
}

a {
  color: #098;
  cursor: pointer;
  text-decoration: underline;
}

.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1080px;
}

.table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

.table thead tr:last-child th,
.table thead tr th[rowspan] {
  border-bottom: 2px solid #ddd;
}

.table--striped tbody tr:nth-of-type(odd) td {
  background-color: #f7f7f7;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

.table--row-hover tbody tr:hover td {
  background-color: #fff7d0;
}

.table th {
  font-weight: 600;
  text-align: left;
}

.table th,
.table td {
  padding: 0.5rem;
}

td.a-center,
th.a-center {
  text-align: center;
}

.ui-progress-linear {
  height: 0.15rem;
  position: absolute;
}

.item-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.ui-collapsible__header-content {
  flex: 1;
}

.ui-button {
  margin-right: 0.5rem;
}

@media print {
  #app {
    color: #000 !important;
  }

  header,
  footer {
    display: none;
  }

  body {
    background: #fff !important;
    font-size: 12pt;
  }

  .page-header {
    border-bottom: none;
    padding-top: 0;
    padding-bottom: 0;
  }

  .page-header h1 {
    font-size: 1.5rem;
    margin-bottom: 0;
  }

  .ui-button {
    display: none;
  }

  .print-hide {
    display: none;
  }
}
</style>
